import { createSlice } from '@reduxjs/toolkit';
import clone from 'clone';
const initialState = {};
export const initialOptionsSlice = createSlice({
    name: 'form-initial-options',
    initialState,
    reducers: {
        setFormInitialOptions: (state, action) => {
            const { form, initialOptions } = action.payload;
            state[form] = clone(initialOptions);
        },
    },
});
export const { setFormInitialOptions } = initialOptionsSlice.actions;
export default initialOptionsSlice.reducer;
